import React from "react";
import { DragSource, DropTarget } from "react-dnd";
import "./style.css";
import { EditableFormRowWrapper } from "./editablecell";

class BodyRow extends React.Component {
  dragingIndex = -1;
  render() {
    const {
      isOver,
      connectDragSource,
      connectDropTarget,
      moveRow,
      editable,
      dataIndex,
      title,
      record,
      index,
      inputType,
      handleSave,
      options,
      url,
      valueKeyName,
      labelKeyName,
      objectKey,
      checkCellValue,
      ...restProps
    } = this.props;
    const style = { ...restProps.style, cursor: "move" };

    let className = restProps.className;
    if (isOver) {
      if (restProps.index > this.dragingIndex) {
        className += " drop-over-downward";
      }
      if (restProps.index < this.dragingIndex) {
        className += " drop-over-upward";
      }
    }
    return connectDragSource(
      connectDropTarget(
        <tr {...restProps} className={className} style={style} />
      )
    );
  }
}

const rowSource = {
  beginDrag(props) {
    this.dragingIndex = props.index;
    return {
      index: props.index
    };
  }
};

const rowTarget = {
  drop(props, monitor) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;
    if (dragIndex === hoverIndex) return;
    props.moveRow(dragIndex, hoverIndex);
    monitor.getItem().index = hoverIndex;
  }
};

export const DragableBodyRow = DropTarget(
  "row",
  rowTarget,
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  })
)(
  DragSource("row", rowSource, connect => ({
    connectDragSource: connect.dragSource()
  }))(BodyRow)
);

export const EditableDragableFormRow = DropTarget(
  "row",
  rowTarget,
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  })
)(
  DragSource("row", rowSource, connect => ({
    connectDragSource: connect.dragSource()
  }))(EditableFormRowWrapper(BodyRow))
);



// WEBPACK FOOTER //
// ./src/components/ui-ant/Datatable/draggable.js